<template>
  <div class="form-date-container" @click="openPicker">
    <input
      ref="dateInput"
      type="date"
      :name="[Name]"
      :id="[Id]"
      :class="['form-date', stateName]"
      :value="value"
      @input="$emit('input', $event.target.value)"
      max="9999-12-31"
    >
  </div>
</template>
<script>
export default {
  props: [
    'state',
    'value',
    'name',
    'id'
  ],
  computed: {
    stateName() {
      return this.state ? `is-${ this.state }` : '';
    },
    Name() {
      return this.name ? `${this.name}` : '';
    },
    Id() {
      return this.id ? `${this.id}` : '';
    }
  },
  methods: {
    openPicker() {
      try {
        this.$refs.dateInput.showPicker();
      } catch (e) {
        // showPicker非対応ブラウザはネイティブの挙動に任せる
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-date-container {
  position: relative;
  width: 100%;
  cursor: pointer;
  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    background-color: #0078d4;
    mask-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5.056 22.56a1.98 1.98 0 0 1-1.45-.607A1.98 1.98 0 0 1 3 20.504V6.112c0-.565.206-1.049.607-1.45.4-.4.884-.606 1.449-.606h1.028V2H8.14v2.056h8.224V2h2.056v2.056h1.028a1.98 1.98 0 0 1 1.45.607c.4.4.606.884.606 1.449v14.392a1.98 1.98 0 0 1-.607 1.45c-.4.4-.884.606-1.449.606zm0-2.056h14.392v-10.28H5.056zm0-12.336h14.392V6.112H5.056zm7.196 6.168a1 1 0 0 1-.73-.298 1 1 0 0 1-.298-.73 1 1 0 0 1 .298-.73 1 1 0 0 1 .73-.298 1 1 0 0 1 .73.298 1 1 0 0 1 .298.73 1 1 0 0 1-.298.73 1 1 0 0 1-.73.298m-4.112 0a1 1 0 0 1-.73-.298 1 1 0 0 1-.298-.73 1 1 0 0 1 .298-.73 1 1 0 0 1 .73-.298 1 1 0 0 1 .73.298 1 1 0 0 1 .298.73 1 1 0 0 1-.298.73 1 1 0 0 1-.73.298m8.224 0a1 1 0 0 1-.73-.298 1 1 0 0 1-.298-.73 1 1 0 0 1 .298-.73 1 1 0 0 1 .73-.298 1 1 0 0 1 .73.298 1 1 0 0 1 .298.73 1 1 0 0 1-.298.73 1 1 0 0 1-.73.298m-4.112 4.112a1 1 0 0 1-.73-.298 1 1 0 0 1-.298-.73 1 1 0 0 1 .298-.73 1 1 0 0 1 .73-.298 1 1 0 0 1 .73.298 1 1 0 0 1 .298.73 1 1 0 0 1-.298.73 1 1 0 0 1-.73.298m-4.112 0a1 1 0 0 1-.73-.298 1 1 0 0 1-.298-.73 1 1 0 0 1 .298-.73 1 1 0 0 1 .73-.298 1 1 0 0 1 .73.298 1 1 0 0 1 .298.73 1 1 0 0 1-.298.73 1 1 0 0 1-.73.298m8.224 0a1 1 0 0 1-.73-.298 1 1 0 0 1-.298-.73 1 1 0 0 1 .298-.73 1 1 0 0 1 .73-.298 1 1 0 0 1 .73.298 1 1 0 0 1 .298.73 1 1 0 0 1-.298.73 1 1 0 0 1-.73.298"/></svg>');
    mask-repeat: no-repeat;
    mask-position: center;
    pointer-events: none;
  }
  &::after {
    content: "";
    display: block;
    background-image: url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2210%22%20height%3D%225%22%20fill%3D%22none%22%3E%3Cpath%20fill%3D%22%230078d4%22%20d%3D%22M5%205%200%200h10z%22%2F%3E%3C%2Fsvg%3E');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    width: 12px;
    height: 6px;
    opacity: 1;
    pointer-events: none;
  }
}
.form-date {
  width: 100%;
  height: 40px;
  border: 1px solid $c-border-2;
  border-radius: 8px;
  font-size: 1.6rem;
  padding: 0 38px;
  appearance: none;
  cursor: pointer;
  &::-webkit-calendar-picker-indicator {
    display: none;
  }
  &::-webkit-datetime-edit-year-field,
  &::-webkit-datetime-edit-month-field,
  &::-webkit-datetime-edit-day-field {
    background: transparent;
    color: #000;
  }

  @media screen and (max-width: $sp_point) {
    width: 100%;
  }
  &.is-error {
    background-color: $c-errorBg;
    border-color: $errorBorder;
  }
  &:disabled{
    background-color: #ebebeb;
  }
  @media screen and (max-width: $sp_point) {
    width: 100%;
  }
}

</style>
